/*
 * @Description: 组织架构
 * @Author: mdb
 * @Date: 2022-08-09 14:57:20
 * @LastEditTime: 2023-06-15 15:52:18
 * @LastEditors: cxh
 */
import { ref, onBeforeMount } from 'vue'
import { labelList } from '@/api/yuntuSales/labelManage'

import { useRequest } from 'vue-request'

export default function (appId: 'cos_fbu' | 'cos_ofbu' | 'cos_lbu') {
  const customerLabelEnum = ref<any>([])
  onBeforeMount(async () => {
    const params = { appId: appId }
    customerLabelEnum.value = await new Promise((resolve, reject) => {
      useRequest(labelList, {
        defaultParams: [params],
        cacheKey: 'appId_label' + JSON.stringify(params),
        onSuccess: (res) => {
          const list = res.data

          resolve(list)
        },
        onError(Error) {
          reject(Error)
        }
      })
    })
  })
  return {
    customerLabelEnum
  }
}
